import ilceler from "../utils/ilceler";
import iller from "../utils/iller";


const getCityAndTown = (text) => {

    //! bu bizdeki ller listesinden illerin filtrelenmiş hali
     const illerList = iller.map(il => il.value.toUpperCase())
 
     //! bu aranan text deki embollerin çıkarılmış ve kelimelerin array haline getirilmiş hali
     const textArr = text.split(/[ \/]/).map(word => word.replace(/[^\w\sğüşıöçĞÜŞİÖÇ]/gi, "")).filter(Boolean);
 
     //! bu text textArr indeki kelimelerin iller listesinde bulunanını bulmak için
     const currentIl = textArr.find((word)=> {
       return illerList.includes(word.toUpperCase())
       })
 
     //! bu belirlenen ilin id sine ulaşmak için
     const ilId = iller.find((item) => {
       return item.value === currentIl
     }).id
 
     const ilceOptions = ilceler.filter((item)=> {
       return item["ilce_sehirkey"] ===ilId
     })
 
     //! bu ile göre belirlenen ilcelerin kendisinin listesi
     const ilcelerList = ilceOptions.map(item => item.value.toLocaleUpperCase('TR'))
 
 
     //! bu text array ının içerisinden ilçeler listesinde bulunanı bulmak için
     const currentIlce = textArr.find((word) => {
       return ilcelerList.includes(word.toLocaleUpperCase('TR'))
     }) 

     const ilceId = ilceler.find((item) => {
      return item.value.toLocaleUpperCase('TR') === currentIlce.toLocaleUpperCase('TR')
     })
     
     return {currentIl ,ilId, currentIlce, ilceOptions, ilceId}
   }

   export default getCityAndTown